"use client";

import { useEffect } from "react";

/** Find a homepage section by id. Hash-prefixed ids are a legacy fallback. */
function findHomepageSection(sectionId: string): HTMLElement | null {
  if (typeof document === "undefined") return null;
  return (
    document.getElementById(sectionId) ??
    document.getElementById(`#${sectionId}`)
  );
}

export function scrollToHomepageSection(sectionId: string): boolean {
  const section = findHomepageSection(sectionId);
  if (!section) return false;
  section.scrollIntoView({ behavior: "smooth" });
  return true;
}

/** Scroll to a homepage hash. Used by the phone header (Contact Us and /# links). */
export function useHomepageHashScroll() {
  useEffect(() => {
    const handleHashNavigation = () => {
      const hash = window.location.hash.replace("#", "");
      if (!hash) return;
      const section = findHomepageSection(hash);
      if (!section) return;
      window.setTimeout(() => {
        section.scrollIntoView({ behavior: "smooth" });
      }, 300);
    };

    handleHashNavigation();
    window.addEventListener("hashchange", handleHashNavigation);
    return () => {
      window.removeEventListener("hashchange", handleHashNavigation);
    };
  }, []);
}
